import {createStore} from 'vuex';
import Activities from "@/store/modules/Activities";
import Users from "@/store/modules/Users";
import Videos from "@/store/modules/Videos";
import VideoAnalysis from "@/store/modules/VideoAnalysis";
import Features from "@/store/modules/Features";
import Profiles from "@/store/modules/Profiles";
import Configurations from "@/store/modules/Configurations";
import Courses from "@/store/modules/Courses";
import Programs from "@/store/modules/Programs";
import Notifications from "@/store/modules/Notifications";
import Documents from "@/store/modules/Documents";
import Sessions from "@/store/modules/Sessions";
import UserInterface from "@/store/modules/UserInterface";
import Dialogs from "@/store/modules/Dialogs";
import Calendar from "@/store/modules/Calendar";
import Certificates from "@/store/modules/Certificates";
import Faqs from "@/store/modules/Faqs";
import Scripts from "@/store/modules/Scripts";
import RolePlay from "@/store/modules/RolePlay";
import AiQuota from "@/store/modules/AiQuota";
import Onboarding from "@/store/modules/Onboarding";

export default createStore({
  modules: {
    activities: Activities,
    users: Users,
    videos: Videos,
    videoAnalysis: VideoAnalysis,
    features: Features,
    profiles: Profiles,
    configurations: Configurations,
    courses: Courses,
    programs: Programs,
    notifications: Notifications,
    documents: Documents,
    sessions: Sessions,
    userInterface: UserInterface,
    dialogs: Dialogs,
    calendar: Calendar,
    certificates: Certificates,
    faqs: Faqs,
    scripts: Scripts,
    roleplay: RolePlay,
    aiQuota: AiQuota,
    onboarding: Onboarding,
  },
});
